<script setup lang="ts"></script>

<template>
    <div class="font-brand text-5xl/12 italic font-light text-center uppercase">
        <div class="text-brand font-black">Poslednik</div>
        Wir Lacken Das
    </div>
</template>
